import { t } from 'i18next';
import { isEmpty } from 'lodash-es';
import React from 'react';

const EmptyFragment = (): React.ReactNode => <></>;

interface ISimpleTabSectionProps {
  activeTabIndex: number;
  sections: React.ReactNode[];
}

export const SimpleTabSections = ({
  activeTabIndex = 0,
  sections = [<EmptyFragment />],
}: ISimpleTabSectionProps) => {
  if (isEmpty(sections)) return null;
  const ActiveSection = sections[activeTabIndex];
  return ActiveSection || <div style={{ fontSize: 'small' }}>{t('ErrorGenericSystemFailure')}</div>;
};
